import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';

const TermsLink = (props: any) => {
  const { intl, brand } = props;

  return (
    <Link
      className={`${brand}-link-text`}
      target="_blank"
      to={intl.formatMessage({ id: `footer.termsOfUse.link.${brand}` })}
    >
      <FormattedMessage id={'termsOfUse'} />
    </Link>
  );
};

export default injectIntl(TermsLink);
